import { gql } from '@apollo/client'

const updateBucketVersionMutation = gql(`
  mutation updateBucketVersion($input: UpdateBucketVersionInput, $bucketId: ID, $module: String, $project: String)
  {
    updateBucketVersion(input: $input, bucketId:$bucketId, module:$module, project:$project){
        id,
    }
  }
`)

export default updateBucketVersionMutation
